import React from 'react';
import { Link } from 'react-router-dom';

export default function CheckoutSuccess() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-900 text-white">
      <div className="max-w-lg text-center p-8">
        <h1 className="text-2xl font-bold mb-4">Payment successful</h1>
        <p className="mb-6">Thank you — your subscription should be active shortly. If it isn't, refresh your account page.</p>
        <div className="space-x-4">
          <Link to="/dashboard" className="btn btn-primary">Go to Dashboard</Link>
          <Link to="/settings" className="btn btn-secondary">Account Settings</Link>
        </div>
      </div>
    </div>
  );
}
